import { hot } from 'react-hot-loader/root';
import React from 'react';
import PropTypes from 'prop-types';
import { Grid, GridElement } from '../design-system/Grid';
import PageWrapper from '../design-system/PageWrapper';
import { Button } from '../design-system/Buttons';
import Container from '../design-system/Containers';
import { formTypeInner } from '../proptypes/forms';
import {
  Form,
} from '../design-system/Forms';
import { HeadingArticle } from '../design-system/Headings';
import { ResponsiveImage } from '../design-system/Images';
import Paragraph from '../design-system/Paragraph';
import LaserBannerPageSection from '../design-system/LaserBannerPageSection';

const ProfileSelectionPage = ({
  profileSelectionForms,
  phrases,
}) => (
  <PageWrapper tallNav bgDark>
    <LaserBannerPageSection borderT>
      <HeadingArticle el="h2">{phrases.title}</HeadingArticle>
      <Paragraph body secondary>{phrases.subtitle}</Paragraph>
      <Container center css={{ maxWidth: '690px' }}>
        {profileSelectionForms.map((data, index) => {
          const isFirstItem = index === 0;
          const isLastItem = index === profileSelectionForms.length - 1;
          return (
            <Form key={data.id} inline {...data} w100 className="ss_w--100">
              <Button type="submit" frameless w100>
                <Grid
                  pxXs
                  pyXs
                  borderT={!isFirstItem}
                  borderB={isLastItem && profileSelectionForms.length > 2}
                  w100
                >
                  <GridElement center>
                    <ResponsiveImage
                      alt=""
                      src="//images.ctfassets.net/gtqjh9j40j4m/3GWFwl0TiP1jdFkJ5fDk2r/b7f00cd4eabd86b68388792b42c8ad90/profile_icon.svg"
                      style={{ width: '30px' }}
                    />
                  </GridElement>
                  <GridElement
                    center
                  >
                    <Grid w100 extent>
                      <GridElement pxSm pyXs>
                        <Paragraph
                          my0
                          intro
                          tAlignL
                          className="ss_tt--uppercase"
                        >
                          {data.fullName}
                        </Paragraph>
                      </GridElement>
                    </Grid>
                  </GridElement>
                </Grid>
              </Button>
            </Form>
          );
        })}
      </Container>
    </LaserBannerPageSection>
  </PageWrapper>
);

ProfileSelectionPage.propTypes = {
  profileSelectionForms: PropTypes.arrayOf(PropTypes.shape({
    ...formTypeInner,
    id: PropTypes.string.isRequired,
    fullName: PropTypes.string.isRequired,
    currentProfile: PropTypes.bool.isRequired,
  })).isRequired,
  dashboardPath: PropTypes.string.isRequired,
  phrases: PropTypes.exact({
    title: PropTypes.string,
    subtitle: PropTypes.string,
  }).isRequired,
};

export default hot(ProfileSelectionPage);
